export const hamburger = (
  <svg
    width="25"
    height="18"
    viewBox="0 0 25 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="1" y1="1" x2="24" y2="1" strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="9" x2="24" y2="9" strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="17" x2="24" y2="17" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
